import React, { useEffect, useState } from "react";
import { useRouteMatch, useHistory } from "react-router-dom";

// component imports
import { CusotomSearch } from "../../utils/resuableComponents/CustomSearch";
import CustomTable from "../../utils/resuableComponents/CustomTable";
import { getEnquireList,enquireListDetailedView } from "../../services/apiServices/PostServices";
import OrderRequestViewModal from "../../utils/resuableComponents/OrderRequestViewModal";
import { columnsUserList,columnsStoresList,contactList,serviceList} from "../../utils/constants/TableHeader";
import Loader from "../loadingScreens/Loader";


const EnquiresList = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [storeData, setStoreData] = useState([]);
    const [enquireListToggle,setEnquireListToggle]=useState(1);
    const [filteredData, setFilteredData] = useState([])
    const [viewModal,setViewModal]=useState(false)
    const [modalViewData,setModalViewData]=useState([])
    const [data,setData]=useState([])
    const [typeVal,setType]=useState(1)
    const [subHeading,setSubHeading]=useState("Contact Us List")
    const [modalHeading,setModalHeading]=useState("Detail view of contact list")
    const [isLoader,setIsLoader]=useState(false)
    const [form,setFrom]=useState("")

    const pathName = undefined

    useEffect(() => { 
       getNewOrderListApi()
    }, [typeVal]);

    useEffect(() => {
        if (filteredData.length != 0) {
            setData(filteredData)
        }
    }, [filteredData.length])

         //function to call api of the getUserList
         const getNewOrderListApi = async () => {
            setIsLoader(true)
            const reqbody = {
                type:typeVal
            }
            const res = await getEnquireList("enquiryList",reqbody);
            if (res.success) {
                const newData = res?.data
                    setFilteredData(newData)
                    setStoreData(newData)
            } else {
                console.log("res", res?.message)
            }
        }

        //function to hanlde search
        const handleSearch = (val) => {
            const searchVal = val
            if (searchVal === "") {
                getNewOrderListApi()
            } else {
                setSearchTerm(searchVal);
                const filterdata = storeData.filter((item) => {
                    if (item?.name.toLowerCase()
                        .includes(searchVal.toLowerCase()) || item?.email.toLowerCase()
                        .includes(searchVal.toLowerCase()) || item?.state.toLowerCase()
                        .includes(searchVal.toLowerCase()) || ( item?.service !== null ?  item?.service.toLowerCase()
                        .includes(searchVal.toLowerCase()) : "" ) || item?.mobile.includes(searchVal)) { return item; }
                })
                
                setFilteredData(filterdata)
            }
        }

        //function to handle tab
        const handleTabContactList = () => {
            setSearchTerm("")
            setEnquireListToggle(1)
            setSubHeading("Contact Us List")
            setType(1)
            setModalHeading("Detail view of contact list")
            
          } 
          
          //function to handle tab onclick
          const handleTabFranchiseList = () => {
            setSearchTerm("")
            setFrom("franchise")
            setEnquireListToggle(0)
            setSubHeading("Franchise Enquires List")
            setType(2)
            setModalHeading("Detail view of Franchise Enquires List")
            
            } 

            //function to handle tab onclick
          const handleTabSupportList = () => {
            setSearchTerm("")
            setEnquireListToggle(2)
            setSubHeading("Support Request")
            setType(0)
            setModalHeading("Detail view of Support Request")
            } 

            const handleDetailedEnquireList = async (data) => {
                const reqbody = {
                        id: data?.id,
                        type: data?.type
                }
               const res = await enquireListDetailedView("enquiryList",reqbody);
                if (res.success) {
                    const newData = res?.data[0]
                    setModalViewData(data)
                    setViewModal(true)
                } else {
                    console.log("res", res?.message)
                }

            }

            //function to call modal view data
            const handleModalView = (data) => {
                if(typeVal === 2){
                    handleDetailedEnquireList(data)
                }else{
                    setModalViewData(data)
                    setViewModal(true)
                }
                
            }

            const handleCloseModal = () => {
                setViewModal(false)
            }

    return (
        <div class="col-md-12 " >
            {isLoader ? <Loader/> : null}
           <div class="d-flex w-50 flex-row  align-items-center w-100 border-bottom p-2">
            <h1 class="fs-4 Montserrat ms-3 fw-semi-bold">
            Enquiry List
            </h1>
            <h6 class="h-25 m-0 fs-6 roboto fw-semi-bold">
            <i class="fas fa-chevron-right fa-xs mx-1"></i>
             {`${subHeading}`}
            </h6>
        </div>
        
        <OrderRequestViewModal open={viewModal} from={form} close={handleCloseModal} data={modalViewData} heading={modalHeading} />

        {/* <hr class="hr w-100 m-0" /> */}
        <div class="d-flex w-100">
            <div class="d-flex  w-75">
             <div class={enquireListToggle === 1 ?" d-flex align-self-end  h-50 mx-4 my-2 roboto tabBorder pointer" :"mx-4 align-self-end  h-50 my-2 roboto pointer"} onClick={handleTabContactList} >
                <h5 class= {enquireListToggle === 1 ? "fw-bold m-0" : "status-pending m-0"}>Contact Us List</h5>
             </div>
             <div class={enquireListToggle === 0 ? " roboto align-self-end tabBorder pointer h-50 my-2" :" align-self-end roboto pointer h-50 my-2"} onClick={handleTabFranchiseList} >
                <h5 class={enquireListToggle === 0 ?"fw-bold m-0 " : "status-pending m-0"}>Franchise Enquires List</h5>
             </div>
             <div class={enquireListToggle === 2 ? "mx-4 align-self-end roboto tabBorder pointer h-50 my-2" :"mx-4 align-self-end roboto pointer h-50 my-2"} onClick={handleTabSupportList} >
                <h5 class={enquireListToggle === 2 ?"fw-bold m-0" : "status-pending m-0"}>Support Requests</h5>
             </div>
             </div>
             
             <CusotomSearch onChange={handleSearch} searchVal={searchTerm}/>
        </div>
        <CustomTable   data={filteredData} columnHeader={typeVal === 2 ? serviceList : contactList} onclickView = {handleModalView} />

        </div>
    )
}

export default EnquiresList